import { DeleteOutlined, FileExcelOutlined, DatabaseOutlined } from '@ant-design/icons'
import { Button, Table, Tooltip } from 'antd'
import moment from 'moment'
import * as React from 'react'
import { Movimento, SorgenteType } from '../../models/RaccoltaDatiModels'
import { formatEuro } from '../shared/CurrencyFormat'

const { Column } = Table

interface TableEntrateProps {
    entrate: Array<Movimento>
    onDeleteMovimento?: (record: Movimento) => void
}

export class TableEntrate extends React.Component<TableEntrateProps, any> {

    constructor(props) {
        super(props)
    }

    getColumn = () => {
        if (this.props.onDeleteMovimento == null) return
        return (
            <Column title="" dataIndex="Id" render={(_, record: Movimento) =>
                <Button type="primary" key="delete-mov-cc" icon={<DeleteOutlined />} size="small" onClick={() => this.props.onDeleteMovimento(record)} />
            } />
        )
    }

    renderTipoSorgente = (value: SorgenteType, record: Movimento) => {
    
        if (value == SorgenteType.Excel) return <Tooltip title="Import da Excel"><FileExcelOutlined style={{ color: "green" }} /></Tooltip>;
        return <Tooltip title="Inserimento da provider"><DatabaseOutlined style={{ color: "gray" }} /></Tooltip>
    
    }

   
    render() {
        return (
            <>
                <h3>Entrate conti correnti</h3>
                <Table
                    dataSource={this.props.entrate}
                    rowKey={it => it.Id}>
                    {this.getColumn()}
                    <Column title="Data" dataIndex="Data" render={(value: Date) => moment(value).format('LL')} />
                    <Column title="Descrizione" dataIndex="Descrizione" />
                    <Column title="Importo" dataIndex="Importo" render={(value: number) => formatEuro(value)} />
                    <Column title="Conto corrente" dataIndex="ContoCorrente" />
                    <Column title="Sorgente" dataIndex="Sorgente"
                        filters={[{ text: "Excel", value: 0 }, { text: "Provider", value: 1 }]}
                        onFilter={(filterValue, record: Movimento) => record.Sorgente == filterValue}
                    render={(value: SorgenteType, record: Movimento) => this.renderTipoSorgente(value, record)}
                    />
                </Table>
            </>
        )
    }
}